import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
@Injectable({
  providedIn: 'root'
})
export class CapacitorSafeService {

  private _isInIframe = window.self !== window.top;

  constructor() {
    if (this._isInIframe) {
      console.warn('⚠️ App en iframe - plugins nativos deshabilitados');
    };
  }

  isInIframe(): boolean {
    return this._isInIframe;
  }

}
